import React, { Suspense, lazy } from 'react';
import Calendar from './pages/Calendar';

// Map component names to their dynamic imports
const componentMap: { [key: string]: React.LazyExoticComponent<React.FC<any>> } = {
    Intro: lazy(() => import('./pages/Intro')),
    GetStarted: lazy(() => import('./pages/GetStarted')),
    CountrySelect: lazy(() => import('./pages/CountrySelect')),
    Form: lazy(() => import('./pages/Form')),
    Map: lazy(() => import('./pages/Map')),
    Multi: lazy(() => import('./pages/Multi')),
    AppliancePicker: lazy(() => import('./pages/AppliancePicker')),
    OffGridAppliances: lazy(() => import('./pages/OffGridAppliances')),
    ProductSelector: lazy(() => import('./pages/ProductSelector')),
    Submit: lazy(() => import('./pages/Submit')),
    Calendar: lazy(() => import('./pages/Calendar')),
    Final: lazy(() => import('./pages/Final')),
};

const loadComponent = (componentName: string) => {
    return componentMap[componentName] || null;
};

const DynamicComponentLoader: React.FC<{ componentName?: string }> = ({ componentName }) => {
    if (!componentName) {
        return <div>Component not found</div>;
    }

    const LazyComponent = loadComponent(componentName);

    if (!LazyComponent) {
        return <div>Component not found</div>;
    }

    return (
        <Suspense fallback={<div></div>}>
            <LazyComponent />
        </Suspense>
    );
};

export default DynamicComponentLoader;
